import { c } from "./emotion-css-create-instance.esm.js";
import { s as i } from "./states.js";
const f = (t) => typeof HTMLElement == "object" ? t instanceof HTMLElement : !!t && typeof t == "object" && t.nodeType === 1, d = (t, o) => {
  var a;
  o.classList.add(i.container);
  const s = document.createElement("div");
  s.className = i.webediaPlayerBannerContainer, o.appendChild(s);
  const l = {
    left: {
      element: null,
      currentContent: null
    },
    center: {
      element: null,
      currentContent: null
    },
    right: {
      element: null,
      currentContent: null
    },
    bottomRight: {
      element: null,
      currentContent: null
    }
  };
  for (const n in l)
    t.banner[`set${c(n)}Banner`] = (r) => {
      var u;
      if (l[n].currentContent === r)
        return;
      let e = l[n].element;
      if (e === null && (e = document.createElement("div"), e.className = i[`webediaPlayerBanner${c(n)}`], s.appendChild(e), l[n].element = e), f(r)) {
        const m = l[n].currentContent;
        f(m) ? (u = l[n].element) == null || u.replaceChild(r, m) : e.appendChild(r);
      } else if (r === null)
        for (; e.firstChild; )
          e.removeChild(e.firstChild);
      else
        e.innerHTML = r ?? "";
      l[n].currentContent = r ?? null, e.classList && e.classList.toggle("safari-bug-fix");
    };
  (a = t.postroll) == null || a.initAsReady();
};
export {
  d as s
};
